import { Col, Row, Statistic } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

function CommonTabContent({ counters }) {
    const { t } = useTranslation();

    return (
        <Row gutter={24}>
            <Col span={12}>
                <Statistic
                    title={t("counters.activeChatsCounter")}
                    value={counters.activeChatsCounter}
                />
            </Col>
            <Col span={12}>
                <Statistic
                    title={t("counters.aiAgentChatsCounter")}
                    value={counters.aiAgentChatsCounter}
                />
            </Col>
            <Col span={12}>
                <Statistic
                    title={t("counters.unassignedChatsCounter")}
                    value={counters.unassignedChatsCounter}
                />
            </Col>
            <Col span={12}>
                <Statistic
                    title={t("counters.waitingAnswerChatsCounter")}
                    value={counters.waitingAnswerChatsCounter}
                />
            </Col>
            <Col span={12}>
                <Statistic
                    title={t("counters.assignedChatsCounter")}
                    value={counters.assignedChatsCounter}
                />
            </Col>
        </Row>
    );
}

export default CommonTabContent;
